import { render, staticRenderFns } from "./RsaConfigurazioneDiariEditComponent.vue?vue&type=template&id=4ce22722"
import script from "./RsaConfigurazioneDiariEditComponent.vue?vue&type=script&lang=js"
export * from "./RsaConfigurazioneDiariEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports